export default "__VITE_ASSET__9b685318__"